module.exports = "https://web-assets.ifttt.com/packs/media/shared/apple-touch-icon-152x152-precomposed-3f079a5a.png";